module.exports = __webpack_public_path__ + "static/media/polaris-heavy.8fba2098.otf";


//////////////////
// WEBPACK FOOTER
// ./src/polaris-heavy.otf
// module id = ./src/polaris-heavy.otf
// module chunks = 0